import React, { useEffect, useState } from "react";
import Loading from "../components/Loading";
import { useDispatch } from "react-redux";
import { markaterLogin } from "../store/markaterSlice";
import { toast } from "react-toastify";
import Cookies from "js-cookie";
import { useNavigate } from "react-router-dom";
import { storeUserData, clearAuthData } from "../utils/auth";

function Login() {
  const [loading, setLoading] = useState();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [input, setInput] = useState({
    phone: "",
    password: "",
  });

  const handelInputChange = (event) => {
    const { name, value } = event.target;
    setInput((prevInputs) => ({ ...prevInputs, [name]: value }));
  };

  useEffect(() => {
    // Clear any existing authentication data
    clearAuthData();
  }, []);

  const saveData = (e) => {
    e.preventDefault();
    setLoading(true);
    
    dispatch(markaterLogin(input))
      .unwrap()
      .then((res) => {
        toast.success("تم تسجيل الدخول بنجاح")
       
        
        // Store user data and JWT token
        // Note: Assuming the backend returns a token field in the response
        // If the backend doesn't return a token yet, we'll store the user data
        // and the token will be handled when the backend is updated
        if (res.token) {
          storeUserData(res, res.token);
        } else {
          // Fallback to storing user data in cookies for backward compatibility
          storeUserData(res, null);
        }
        
        setTimeout(() => {
          setLoading(false);
          navigate("/agent/dashboard");
          window.location.reload();
        }, 1000);
      })
      .catch((err) => {
        console.error(err.data);
        
        setLoading(false);
      });
  };

  return (
    <>
      {loading ? <Loading open={true} /> : ""}
      <div className="login_page">
        <img
          className="wavelogin"
          src={`${process.env.PUBLIC_URL}/images/wavelogin.svg`}
          alt=""
        />
        <div className="container">
          <div className="login_form">
            <div className="logo">
              <img src={`${process.env.PUBLIC_URL}/images/logo.svg`} alt="" />
            </div>
            <form action="" onSubmit={saveData}>
              <div className="form-group">
                <label htmlFor="">رقم الهاتف</label>
                <input
                  name="phone"
                  value={input.phone}
                  type="text"
                  className="form-control"
                  placeholder="example@example.com"
                  onChange={handelInputChange}
                />
              </div>
              <div className="form-group">
                <label htmlFor="">كلمه المرور</label>
                <input
                  name="password"
                  value={input.password}
                  type="password"
                  className="form-control"
                  placeholder="**********"
                  onChange={handelInputChange}
                />
              </div>
              <div className="btn_submit">
                <button className="btn">تسجيل الدخول</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
}

export default Login;
